/* tslint:disable:no-var-requires */
import '@/libs/jquery/index'
import '@/libs/jquery/validation'
import '@/libs/jquery_ujs/index'

// require tablesorter/dist/js/jquery.tablesorter.js
import tablesorter from 'tablesorter/dist/js/jquery.tablesorter.min'

import * as bowser from 'bowser'

// # библиотека подключается в head, сборник всех вендорных библиотек для админки
// require jquery.remotipart
import 'jquery-remotipart/src/jquery.remotipart.js'
// require materialize-css/dist/js/materialize.min.js
import 'materialize-css/dist/js/materialize.min'
// require underscore/underscore.js
import * as _ from 'underscore'

// require jquery.autosize.min.js
import 'autosize/build/jquery.autosize'
// require colResizable-1.6.min.js
import 'colresizable/colResizable-1.6.min'

// require unorm/lib/unorm.js
import 'unorm'

// require js-cookie/src/js.cookie.js
import Cookies from 'js-cookie/src/js.cookie'

// require jquery-jeditable/dist/jquery.jeditable.min.js
import 'jquery-jeditable/dist/jquery.jeditable.min'

// require js-routes
import Routes from '@/config/routes/routes.js'
// require moment/moment.js
// require moment/locale/ru.js
import { moment } from '@/libs/moment'

// require cocoon
require('cocoon-js')

// require urijs/src/URI.min.js
import URI from 'urijs'

require ('$app/crm/base.js')

import { FormatStrings } from '@/utilities/format_strings'

declare global {
  /* tslint:disable:interface-name */
  interface Window {
    /* tslint:enable:interface-name */
    FormatStrings
  }
}
window.FormatStrings = FormatStrings
window.tablesorter = tablesorter
window._ = _
window.Cookies = Cookies
window.URI = URI
window.moment = moment
window.Routes = Routes
